import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './NotificationsSidebar.sass'
import NotificationsSidebarViewModel from './NotificationsSidebarViewModel'
import { useOnEscDown } from 'hooks/key-press'
import { useActivation } from 'hooks/mobx-hooks'
import NotificationsSidebarHeader from './NotificationsSidebarHeader'
import NotificationsSidebarMenu from './NotificationsSidebarMenu'
import NotificationList from '../NotificationList'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'

interface Props {
  vm: NotificationsSidebarViewModel
}

export default observer(function NotificationsSidebar({ vm }: Props) {
  useActivation(vm)
  useOnEscDown(vm.showing.disable)
  const mainRef = React.useRef<HTMLDivElement>(null)
  const scrollOffset = useScrollOffsetSpring(mainRef)
  return (
    <div
      className={cx(styles.root, vm.showing.isEnabled && styles.showing)}
      data-test="NotificationsSidebar"
    >
      <div className={styles.overlay} onClick={vm.showing.disable} />
      <div className={styles.panel}>
        <NotificationsSidebarMenu vm={vm} />
        <div className={styles.main} ref={mainRef}>
          <NotificationsSidebarHeader vm={vm} scrollOffset={scrollOffset} />
          <NotificationList vm={vm.list} />
          <div className={styles.gradient} />
        </div>
      </div>
    </div>
  )
})
